import { type DraggableProvided } from 'react-beautiful-dnd'
import { type FC } from 'react'
import classnames from 'classnames'
import { Icon } from 'shared/ui'
import { type Integration, IntegrationKey } from 'entities/Integrations'
import { type Contact } from 'entities/Contacts/model/Contact'
import styles from 'widgets/ContactsDetails/ui/ContactsIntegrations/ui/styles.module.scss'
import { type IBlocksTypes } from 'widgets/ContactsDetails/store/contactsDetailsGlobalStore'
import { DraggingIcon } from './DraggingIcon'
import { StatusIcon } from './StatusIcon'

type IIntegrationTitleProps = {
  integration: Integration | null
  contact: Contact
  hideDraggingIcon?: boolean
  dragHandleProps: DraggableProvided['dragHandleProps']
  isIntegrationActive: boolean
  createNewContactMode?: boolean
  integrationBlockViewKey: IBlocksTypes
}

export const IntegrationTitle: FC<IIntegrationTitleProps> = ({
  hideDraggingIcon,
  dragHandleProps,
  integration,
  contact,
  isIntegrationActive,
  createNewContactMode,
  integrationBlockViewKey,
}) => {
  if (
    (!isIntegrationActive && contact.integration_key === IntegrationKey.salesmsg) ||
    createNewContactMode
  ) {
    return (
      <div className={styles.titleWrapper}>
        <DraggingIcon
          hideDraggingIcon={hideDraggingIcon}
          dragHandleProps={dragHandleProps}
          integrationBlockViewKey={integrationBlockViewKey}
        />

        <span className={styles.integrationIcon}>
          <Icon icon={'add'} />
        </span>
        <span className={styles.title}>Integration</span>
      </div>
    )
  }

  return (
    <div className={styles.titleWrapper}>
      <DraggingIcon
        hideDraggingIcon={hideDraggingIcon}
        dragHandleProps={dragHandleProps}
        integrationBlockViewKey={integrationBlockViewKey}
      />

      {integration && (
        <span className={styles.integrationIcon}>
          <Icon icon={integration.icon} />
        </span>
      )}
      <span className={styles.title}>{integration?.name}</span>
      <span
        className={classnames(styles.statusIcon, {
          [styles.active]: !!integration,
        })}
      >
        <StatusIcon isActive={isIntegrationActive} />
      </span>
    </div>
  )
}
